import { FilterMatchMode } from 'primereact/api';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { MultiSelect } from 'primereact/multiselect';
import { TriStateCheckbox } from 'primereact/tristatecheckbox';
import { useContext, useEffect, useRef, useState } from 'react';
import { whereIsThisContext } from '../../contexts/WhereIsThisContext';
import service from './services/service';

import { Feature } from 'ol';
import AnimatedCluster from "ol-ext/layer/AnimatedCluster";
import { Cluster, Vector as VectorSource } from 'ol/source';
import { Circle, Fill, Stroke, Style, Text } from 'ol/style';
import { useTranslation } from 'react-i18next';


//Bu komponent kullanıcının oluştrdukları tablo verilerini listelemek filitrelemek ve harita göstermek amacıya table cruddan ayırarak oluşturulmuştur
export const TableDataList = (props) => {
    const { t } = useTranslation();

    const [selectedColumns, setSelectedColumns] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedTable, setSelectedTable] = useState({});
    const [columns, setColumns] = useState([]);
    const [datas, setDatas] = useState([]);
    const [filters, setFilters] = useState({});
    const [totalRecords, setTotalRecords] = useState(0);
    const [lazyParams, setLazyParams] = useState(null);
    const [mapTool, setMapTool] = useState(null);
    const [overlayMap, setOverlayMap] = useState(null);
    const popup_info_key = props.layerName + "-popup-info";
    const [whereIsState, whereIsAction] = useContext(whereIsThisContext);
    let overlay = null;
    const toast = useRef(null);
    useEffect(() => {
        window["dynamicTableApiToken"] = props.tokenKey;
        let layerName = props.layerName;


        if (props.mapTool) {
            let mapTool = props.mapTool;

            const getOverlayByName = (name) => {
                var overlays = mapTool.getMap().getOverlays().getArray();

                var selectedOverlay = overlays.find(function (overlay) {
                    return overlay.options.id === name;
                });

                return selectedOverlay;

            };
            let overlay = getOverlayByName(props.layerName + "-popup");

            setMapTool(mapTool);
            if (props.layerName) {
                try {
                    overlay = props.MapTool?.getOverlay(props.layerName + "-popup");
                    if (overlay) {
                        mapTool.getMap().removeOverlay(overlay);
                        overlay = mapTool.addOverlayCustom(props.layerName + "-popup");
                    }
                }
                catch { }
            }

            if (mapTool.findLayer(layerName) != null) {

                mapTool.getMap().removeLayer(mapTool.findLayer(layerName));
            }

            const layer = props.MapTool?.createVectorLayer({
                name: layerName,
                source: props.MapTool?.createVectorLayerSource({})
            });
            mapTool.addLayer(layer);

            if (props.isPopup) {
                try {
                    if (!overlay) {
                        overlay = mapTool.addOverlayCustom(props.layerName + "-popup", props.layerName + "-popup");
                        setOverlayMap(overlay);
                        overlay.setPosition(undefined);
                    }
                    else {
                        overlay.setPosition(undefined);
                    }
                }
                catch { }
                mapTool.getMap().on('singleclick', (evt) => {
                    overlay.setPosition(undefined);
                    const container = document.getElementById(props.layerName + '-popup');
                    container.style.width = "0px";
                    const coordinate = evt.coordinate;
                    const feature = mapTool.getMap().forEachFeatureAtPixel(evt.pixel,
                        function (feature) {
                            if (feature.get("features") && feature.get("features").length === 1) {
                                let ft = feature.get("features")[0];
                                return ft;

                            }
                            else if (feature.get("layerName") && feature.get("layerName") === props.layerName) {
                                return feature;
                            }
                        });
                    if (feature && feature.get(popup_info_key)) {

                        container.style.width = "400px";
                        const content = document.getElementById(props.layerName + '-popup-content');
                        const closer = document.getElementById(props.layerName + '-popup-closer');
                        var object = feature.get(popup_info_key);
                        var columns = feature.get("columns")?.filter(x => x.name !== "geoloc");

                        let html = "";
                        html += '<table class="info-table" border="1" style="border-collapse: collapse; width: 100%;">';
                        html += '<tbody>';

                        for (const element of columns) {
                            var key = element.name;
                            if (key.indexOf("geoloc") <= -1) {
                                let value = object[key];
                                html += '<tr><td>' + (element.displayName == null ? key : element.displayName) + '</td><td>' + value + '</td></tr>';
                            }
                        }

                        content.innerHTML = html;


                        overlay.setPosition(coordinate);
                        return;
                    }

                });
            }

        }
        if (props.isActiveTable) {
            return getActiveTable();
        }
        if (props.table && props.table.id) {
            setSelectedTable(props.table);
            getColumns(props.table.id);
        }

    }, []);

    useEffect(() => {
        if ((props.table && props.table.id) || (selectedTable && selectedTable.id)) {
            if (selectedTable)
                getTableData(selectedTable.id);
            else
                getTableData(props.table.id);
        }
    }, [lazyParams, selectedTable, whereIsState]);
    let loadLazyTimeout = null;
    //İlgili tablonun dataları çekmek için kullanılır

    //Eğer kullanıcı bu componenti map tarafından çağırdaysa isActiveTable propertysi true ise aktif olan tablo sorgulanacaktır 
    const getActiveTable = () => {

        service.get(props.apiUrl + "/CustomerTable/GetActiveTableUser?_tableType=" + props.tableType).then(response => {
            if (response === "") {
                return;
            }
            if (!response.success) {
                return;
            }
            let table = response.data[0];
            setSelectedTable(table);
            getColumns(table.id);

        });
    }
    //Seçili tablonun verilerinin servisten çekilmesini sağlar
    const getTableData = (tableId) => {

        if (loadLazyTimeout) {
            clearTimeout(loadLazyTimeout);
        }
        if (!lazyParams)
            return;

        let filterData = [];

        let sendKeys = Object.keys(lazyParams.filters);
        filterData = sendKeys.map(x => ({ key: x, value: lazyParams.filters[x].value?.toString() })).filter(x => x.value !== null && x.value);
        setLoading(true);

        loadLazyTimeout = setTimeout(() => {
            service.post(props.apiUrl + "/CustomerCrud/DynamicTableQuery?_tableId=" + tableId + "&_limit=" + lazyParams.rows + "&_offset=" + (lazyParams.page ? lazyParams.page : 0), filterData).then(response => {
                if (response === "") {
                    return;
                }
                if (!response.success) {
                    setDatas([]);
                    setLoading(false);
                    return;
                }
                setDatas(response.data.data);
                setTotalRecords(response.data.totalRecords);
                setLoading(false);
                //setLazyParams(lazyParams);
            }).catch(e => {
                console.log(e);
                setLoading(false);
            });

        }, Math.random() * 1000 + 250);

    }
    //İlgili tablonun kolon yapısını çeker
    const getColumns = (tableId) => {

        service.get(props.apiUrl + "/CustomerTable/GetTableColumns?_tableId=" + tableId).then(response => {
            if (response === "") {
                return;
            }
            if (!response.success) {
                return;
            }
            let columns = response.data.filter(x => x.userAdded).map(x => ({
                name: x.name,
                type: x.type,
                required: x.isRequired,
                isActive: true,
                id: x.id,
                displayName: x.displayName === null ? x.name : x.displayName
            }));
            setColumns(columns);

            let filtersTemp = { ...filters };
            for (var i = 0; i < columns.length; i++) {
                if (columns[i].type === "Boolean") {
                    filtersTemp[columns[i].name] = { value: null, matchMode: FilterMatchMode.CONTAINS };
                }
                else {
                    filtersTemp[columns[i].name] = { value: '', matchMode: FilterMatchMode.CONTAINS };
                }
            }
            filtersTemp["id"] = { value: '', matchMode: FilterMatchMode.CONTAINS };
            setLazyParams({
                first: 0,
                rows: props.rows ? props.rows : 20,
                page: 0,
                sortField: null,
                sortOrder: null,
                filters: filtersTemp
            });

            setSelectedColumns(columns);
        });
    }

    //İlgii kolonun tipini almak için kullanılan hepler methoddur.
    const getColumn = (field) => {

        return columns.find(x => x.name === field);
    }

    const formatDate = (value) => {
        return value.toLocaleDateString('tr-TR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };


    //Veri listelenirlen tipine göre template oluşmasını sağlar
    const defaultTemplate = (rowData, { field }) => {
        switch (getColumn(field).type) {
            case "DateTime":
                return formatDate(new Date(rowData[field]));
            case "Geometry":
                return rowData["geoloc_wkt"];
            case "Boolean":
                return rowData[field] ? t('tableDataList.active') : t('tableDataList.passive');

            default:
                return rowData[field] ? (rowData[field].toString().length > 20 ? rowData[field].toString().substr(0, 19) + "..." : rowData[field].toString()) : rowData[field]
        }
    }

    const onPage = (event) => {
        setLazyParams(event);
    }
    const onFilter = (event) => {
        setLazyParams(event);
    }
    //DAtetime ve Boolean alanlar gibi özel değerleri  sorgulamak için  eklenmiştir.Filitreleme işleminde çalışır
    const filterCustomTemplate = (options) => {
        let lazyParamsNew = { ...lazyParams };
        let value = lazyParamsNew.filters[options.field]["value"];

        switch (getColumn(options.field).type) {
            case "Boolean":
                return <TriStateCheckbox value={value ? value : null} onChange={(e) => {
                    options.filterApplyCallback(e.value)
                    lazyParamsNew.filters[options.field]["value"] = e.value;
                    //setLazyParams(lazyParamsNew);
                }} />;
            case "DateTime":
                return <Calendar onChange={(e) => {
                    options.filterApplyCallback(formatDate(e.value));
                    lazyParamsNew.filters[options.field]["value"] = formatDate(e.value);
                }}></Calendar>

            default: return null
        }
    };
    //Harita tarafında tablo gösterilirken tablo üstüne haritada göster ve haritayı temizle butonları eklenir
    const renderHeaderQuery = () => {
        if (!props.isEdit) {
            return (
                <>
                    <div class="formgroup-inline">
                        <div class="field">
                            <Button type="button" icon="pi pi-map" label={t('tableDataList.showAllOnMap')} outlined onClick={showMap} />
                        </div>
                        <div class="field">
                            <Button type="button" severity="danger" icon="pi pi-map" label={t('tableDataList.clearMap')} outlined onClick={clearMap} />
                        </div>
                        <MultiSelect filterLocale="tr" filter placeholder={t('tableDataList.selectColumnsPlaceholder')} maxSelectedLabels={5} value={selectedColumns} options={columns} optionLabel={"displayName"} onChange={(e) => setSelectedColumns(e.value)} />
                    </div>


                </>
            );
        }
        return null;
    };
    const renderShowMapButton = (rowData) => {
        if (!props.isEdit) {
            return (
                <div className="flex justify-content-between">
                    <Button type="button" icon="pi pi-map" style={{ marginRight: "5px" }} severity="Primary" outlined onClick={() => showMapOnly(rowData)} />
                    <Button type="button" icon="pi pi-pencil" severity="warning" outlined onClick={() => {
                        if (props.onEdit) {

                            props.onEdit(rowData);
                        }
                    }} />
                </div>
            );
        }
        return null;
    };
    const showMapOnly = (rowData) => {


        if (mapTool.findLayer(props.layerName) != null) {

            mapTool.getMap().removeLayer(mapTool.findLayer(props.layerName));
        }

        const layer = props.MapTool?.createVectorLayer({
            name: props.layerName,
            source: props.MapTool?.createVectorLayerSource({})
        });
        mapTool.addLayer(layer);

        if (rowData["geoloc_wkt"]) {
            props.mapTool.clearLayersByName([props.layerName]);
            let feature = props.MapTool?.convertToFeature(rowData["geoloc_wkt"], "EPSG:4326", "EPSG:3857");
            if (!feature)
                return;

            feature.set(popup_info_key, rowData);
            feature.set("layerName", props.layerName);
            feature.set("columns", columns);
            feature.setStyle(props.mapTool.setFeatureStyleIcon({ src: process.env.PUBLIC_URL + "/marker_blue.png" }));
            mapTool.addFeature(props.layerName, feature);
            mapTool.viewLayerExtent(props.layerName, feature);

        }
    }
    //İlgili layerin temizlenmesi sağlar
    const clearMap = () => {
        let layers = [props.layerName, props.layerName + "-cluster"];
        for (var i = 0; i < layers.length; i++) {
            if (props.mapTool.findLayer(layers[i])) {
                mapTool.getMap().removeLayer(props.mapTool.findLayer(layers[i]));
            }
        }

    }


    const showLoading = (data) => {
        if (props.loadingAction) {
            props.loadingAction.setIsLoading(data);
        }
    }
    //Tablo verilerinin tümü veya filitreye uyan verilerin haritada gösterilmesi sağlar
    const showMap = () => {
        let sendKeys = Object.keys(lazyParams.filters);
        let filterData = sendKeys.map(x => ({ key: x, value: lazyParams.filters[x].value?.toString() })).filter(x => x.value !== null && x.value);
        clearMap();
        showLoading(true);
        service.post(props.apiUrl + "/CustomerCrud/DynamicTableQuery?_tableId=" + selectedTable.id, filterData).then(response => {
            showLoading(false);
            if (response === "") {
                return;
            }
            if (!response.success) {

                return;
            }

            let features = [];
            for (var i = 0; i < response.data.length; i++) {

                if (response.data[i]["geoloc_wkt"]) {
                    let feature = props.MapTool?.convertToFeature(response.data[i]["geoloc_wkt"], "EPSG:4326", "EPSG:3857");
                    feature.set(popup_info_key, response.data[i]);
                    feature.set("layerName", props.layerName);
                    feature.set("columns", columns);
                    // feature.setStyle(props.mapTool.setFeatureStyleIcon({ src: process.env.PUBLIC_URL + "/marker_blue.png" }));
                    //mapTool.addFeature(props.layerName, feature);
                    features.push(feature);
                }

            }


            var styleCache = {};
            const getStyle = (feature, resolution) => {
                var size = feature.get('features').length;
                var style = styleCache[size];
                if (!style) {
                    var color = size > 25 ? "32, 152, 171" : size > 8 ? "0, 153, 76" : "0, 102, 51";
                    var radius = Math.max(8, Math.min(size * 0.75, 20));
                    if (size > 1) {
                        style = styleCache[size] = [
                            new Style({
                                image: new Circle({
                                    radius: radius + 2,
                                    stroke: new Stroke({
                                        color: "rgba(" + color + ",0.8)",
                                        width: 4
                                    })
                                })
                            }),
                            new Style({
                                image: new Circle({
                                    radius: radius,
                                    fill: new Fill({
                                        color: "rgba(" + color + ",0.8)"
                                    })
                                }),
                                text: new Text({
                                    font: 'bold 14px Arial',
                                    text: size.toString(),
                                    fill: new Fill({
                                        color: '#fff'
                                    })
                                })
                            })
                        ];
                    }
                    else {
                        style = styleCache[size] = [
                            props.mapTool.setFeatureStyleIcon({ src: process.env.PUBLIC_URL + "/marker_blue.png" })
                        ];
                    }

                }
                return style;
            }


            const offsetFeatures = features.map((feature, index) => {
                const geometry = feature.getGeometry();
                const coords = geometry.getCoordinates();

                const offsetX = Math.random() * 5 - 2.5;
                const offsetY = Math.random() * 5 - 2.5;

                const newCoords = [coords[0] + offsetX, coords[1] + offsetY];
                geometry.setCoordinates(newCoords);

                let newFeature = new Feature(geometry);

                newFeature.set(popup_info_key, feature.get(popup_info_key));

                newFeature.set("layerName", props.layerName);

                newFeature.set("columns", feature.get("columns"));

                return newFeature;
            });

            const vectorSource = new VectorSource({
                features: offsetFeatures,
            });


            const clusterSource = new Cluster({
                distance: 40, // Piksel cinsinden cluster mesafesi
                source: vectorSource,
            });



            const clusterLayer = new AnimatedCluster({
                name: props.layerName + "-cluster",
                source: clusterSource,
                style: getStyle,
            });


            mapTool.addLayer(clusterLayer);
            mapTool.viewLayerExtent(props.layerName);

        }).catch(e => {
            showLoading(false);
            console.log(e);

        });
    }
    if (!lazyParams)
        return null;

    return (
        <>


            <div id={props.id} >

                <DataTable
                    size="small"
                    header={renderHeaderQuery}
                    onFilter={onFilter}
                    dataKey="id"
                    lazy
                    filters={lazyParams.filters}
                    loading={loading}
                    onPage={onPage}
                    first={lazyParams.first}
                    filterDisplay="row"
                    paginator
                    rows={lazyParams.rows}
                    selectionMode="single"
                    editMode={props.isEdit ? "cell" : "row"}
                    value={datas}
                    totalRecords={totalRecords}
                    responsiveLayout="scroll" >
                    <Column header="" body={renderShowMapButton}></Column>
                    <Column filter showFilterMenu={false} header="id" field="id"></Column>
                    {selectedColumns.filter(x => x.type !== "Geometry").map(x => <Column showFilterMenu={false} filterField={x.name} filterPlaceholder={x.displayName}
                        filter
                        filterElement={(x.type === "Boolean" || x.type === "DateTime") && filterCustomTemplate}
                        field={x.name} header={x.displayName}
                        body={defaultTemplate}

                    ></Column>)}
                </DataTable>


            </div >
        </>
    )

}

export default TableDataList;